
// export const capitalize=(str)=>{
//   return str.replace(/\b\w/g, function(char) {
//       return char.toUpperCase();
//   });
// }
// export const formatDate = (inputDate) => {
//   // Check if inputDate is null or undefined
//   if (!inputDate) {
//     return null; // You can choose any default value or error message
//   }

//   // Parse input date string into a Date object
//   const date = new Date(inputDate);

//   // Check if the parsed date is valid
//   if (isNaN(date)) {
//     return null; // Return a message if the date is invalid
//   }

//   // Extract date components
//   const month = date.getMonth() + 1;
//   const day = date.getDate();
//   const year = date.getFullYear();

//   // Format the date components with leading zeros if needed
//   const formattedMonth = month < 10 ? '0' + month : month;
//   const formattedDay = day < 10 ? '0' + day : day;

//   // Construct the formatted date string
//   const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;

//   // Return the formatted date string
//   return formattedDate;
// }


import UIConfig from "../constants/UIConfig";

export const formatDate = (inputDate) => {
  if (!inputDate) return null;

  const date = new Date(inputDate);
  if (isNaN(date)) return null;

  const options = {
    timeZone: UIConfig.branding.timeZone || "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(date);
  const dateObj = {};
  parts.forEach(({ type, value }) => {
    dateObj[type] = value;
  });

  return `${dateObj.month}/${dateObj.day}/${dateObj.year}`;
};
export const formatDateForFilter = (dateString) => {
  if (!dateString) return "";

  // Handle formats like "26-02-10"
  if (dateString.includes("-")) {
    const parts = dateString.split("-");

    // Case: YY-MM-DD → 26-02-10
    if (parts[0].length === 2) {
      const [yy, mm, dd] = parts;
      return `${mm}/${dd}/${yy}`;
    }

    // Case: YYYY-MM-DD
    if (parts[0].length === 4) {
      const [yyyy, mm, dd] = parts;
      return `${mm}/${dd}/${yyyy.slice(2)}`; // convert to YY
    }
  }

  // Fallback
  const date = new Date(dateString);
  if (isNaN(date)) return dateString;

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(2);

  return `${mm}/${dd}/${yy}`;
};